/**
 * Smart email opener:
 * - Mobile: uses mailto: which opens native email app (Gmail, Mail, etc.)
 * - Desktop: tries mailto: first, then falls back to Gmail web compose
 */

function isMobile() {
  return /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function openEmail({ to, subject, body }) {
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  const mailtoUrl = `mailto:${to}?subject=${encodedSubject}&body=${encodedBody}`;

  if (isMobile()) {
    // On mobile, mailto: opens native email app directly
    window.location.href = mailtoUrl;
  } else {
    // On desktop: open Gmail compose in new tab (most common web email)
    // mailto: will also work if they have a desktop client, but Gmail web is more reliable
    const gmailUrl = `https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(to)}&su=${encodedSubject}&body=${encodedBody}`;
    window.open(gmailUrl, '_blank');
  }
}

export function openContactEmail() {
  openEmail({
    to: 'contact@mail.samtwoentertainment.com',
    subject: 'Contact SAMTWO',
    body: ''
  });
}
